import React, { useState, useEffect } from "react";
import { QRCodeCanvas } from "qrcode.react";
import { useSearchParams } from "react-router-dom";
import { Box, Typography } from "@mui/material";
import Dashboard from "./Dashboard";
import { getUserLocalData } from "../lib/helper";

const QRCodePage = () => {
  const {  code, verifier } = getUserLocalData();
  
  const qrUrl ={ 
    client_id: process.env.REACT_APP_CLIENT_ID,
    redirect_uri: process.env.REACT_APP_REDIRECT_URI,
    grant_type: "authorization_code",
    code: code, 
    code_verifier: verifier, 
     };

  return (
    <>
      <Dashboard active={"qr"}>
        <Box className="main-content" elevation={3}>
          <Box component={"div"} className="qr">
            {code && verifier  ? (
              <QRCodeCanvas
                value={JSON.stringify(qrUrl)}
                size={356}
                style={{ padding: "18px", backgroundColor: "#fff" }}
              />
            ) : (
              <Typography>Loading QR Code...</Typography>
            )}
          </Box>
        </Box>
      </Dashboard>
    </>
  );
};

export default QRCodePage;
